interface Action {
  type: string;
  payload: any;
}

type FileHeaders = {
  id: string;
  label: string;
  value: string;
  isSelected?: boolean;
  wrongHeader?: boolean;
};
type CustomFieldsCount = {
  accounts: number;
  contacts: number;
};

export const SET_IMPORTING_CONTACTS_STATUS = 'SET_IMPORTING_CONTACTS_STATUS';
export const SET_IMPORTING_FILE_NAME = 'SET_IMPORTING_FILE_NAME';
export const SET_CONTACT_OWNERS = 'SET_CONTACT_OWNERS';
export const SET_CUSTOM_HEADERS = 'SET_CUSTOM_HEADERS';
export const SET_CSV_FIELDS_ARRAY = 'SET_CSV_FIELDS_ARRAY';
export const SET_DROPDOWN_VALUES = 'SET_DROPDOWN_VALUES';
export const SET_MAPPED_FIELDS_COUNT = 'SET_MAPPED_FIELDS_COUNT';
export const SET_UNMAPPED_MAND_FIELDS = 'SET_UNMAPPED_MAND_FIELDS';
export const SET_MANDATORY_FIELDS_MAPPED = 'SET_MANDATORY_FIELDS_MAPPED';
export const SET_FORMATED_DATA = 'SET_FORMATED_DATA';
export const SET_CUSTOM_FIELDS_COUNT = 'SET_CUSTOM_FIELDS_COUNT';
export const SET_IMPORT_COMPLETED_STEPS = 'SET_IMPORT_COMPLETED_STEPS';
export const SET_IMPORTING_CONTACTS_COUNT = 'SET_IMPORTING_CONTACTS_COUNT';

export const setImportingFileName = (fileName: string) => ({
  type: SET_IMPORTING_FILE_NAME,
  payload: fileName,
});

export const setContactOwners = (owners: any) => ({
  type: SET_CONTACT_OWNERS,
  payload: owners,
});

export const setCustomHeaders = (headers: any) => ({
  type: SET_CUSTOM_HEADERS,
  payload: headers,
});

export const setCsvFieldsArray = (csvFields: FileHeaders[]) => ({
  type: SET_CSV_FIELDS_ARRAY,
  payload: csvFields,
});

export const setDropdownValues = (value: FileHeaders[]) => ({
  type: SET_DROPDOWN_VALUES,
  payload: value,
});

export const setMappedFieldsCount = (value: number) => ({
  type: SET_MAPPED_FIELDS_COUNT,
  payload: value,
});

export const setUnMappedMandFields = (value: any) => ({
  type: SET_UNMAPPED_MAND_FIELDS,
  payload: value,
});

export const setMandatoryFieldsMapped = (value: boolean) => ({
  type: SET_MANDATORY_FIELDS_MAPPED,
  payload: value,
});

export const setFormatedData = (value: string) => ({
  type: SET_FORMATED_DATA,
  payload: value,
});

export const setCustomFieldsCount = (value: CustomFieldsCount) => ({
  type: SET_CUSTOM_FIELDS_COUNT,
  payload: value,
});

export const setImportCompletedSteps = (value: { [k: number]: boolean }) => ({
  type: SET_IMPORT_COMPLETED_STEPS,
  payload: value,
});

export const setImportingContactsCount = (value: number) => ({
  type: SET_IMPORTING_CONTACTS_COUNT,
  payload: value,
});

const initialState = {
  importingFileName: '',
  contactOwners: [],
  customHeaders: [],
  csvFieldsArray: [],
  dropdownValues: [],
  mappedFieldsCount: 0,
  unMappedMandFields: [],
  isMandatoryFieldsMapped: false,
  formattedData: '',
  customFieldsCount: {
    accounts: 0,
    contacts: 0,
  },
  importCompletedSteps: { 0: false },
  importingContactsCount: 0,
};

const setImportContactsReducer = (state = initialState, action: Action) => {
  switch (action.type) {
    case SET_IMPORTING_FILE_NAME:
      return { ...state, importingFileName: action.payload };
    case SET_CONTACT_OWNERS:
      return { ...state, contactOwners: action.payload };
    case SET_CUSTOM_HEADERS:
      return { ...state, customHeaders: action.payload };
    case SET_CSV_FIELDS_ARRAY:
      return { ...state, csvFieldsArray: action.payload };
    case SET_DROPDOWN_VALUES:
      return { ...state, dropdownValues: action.payload };
    case SET_MAPPED_FIELDS_COUNT:
      return { ...state, mappedFieldsCount: action.payload };
    case SET_UNMAPPED_MAND_FIELDS:
      return { ...state, unMappedMandFields: action.payload };
    case SET_MANDATORY_FIELDS_MAPPED:
      return { ...state, isMandatoryFieldsMapped: action.payload };
    case SET_IMPORT_COMPLETED_STEPS:
      return { ...state, importCompletedSteps: action.payload };
    case SET_FORMATED_DATA:
      return { ...state, formattedData: action.payload };
    case SET_CUSTOM_FIELDS_COUNT:
      return { ...state, customFieldsCount: action.payload };
    case SET_IMPORTING_CONTACTS_COUNT:
      return { ...state, importingContactsCount: action.payload };
    default:
      return state;
  }
};

export default setImportContactsReducer;
